function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import axios from 'axios';
import { actionCreators as authenticationLibActions } from '../authentication/actions';
import { API_TIMEOUT, handleApiResponse } from '../../utils/api';
import isBrowser from '../../utils/isBrowser';
var authenticationActions = authenticationLibActions.authentication;

var axiosFetch = function axiosFetch(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var bearerToken = arguments.length > 2 ? arguments[2] : undefined;
  return axios(_objectSpread(_objectSpread({
    url: url
  }, params), {}, {
    headers: _objectSpread({
      'Content-Type': 'application/json; charset=utf8',
      Authorization: "Bearer ".concat(bearerToken)
    }, params.headers),
    // Axios uses proxy by default, if HTTP_PROXY or HTTPS_PROXY is set.
    // Which are set on-prem and that causes issues for internal requests
    proxy: false,
    timeout: API_TIMEOUT
  }));
};

export var apiFetch = function apiFetch(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    return axiosFetch(url, params, getState().authentication.bearerToken).then(function (response) {
      if (response.status === 401) {
        if (getState().authentication.loggedIn && isBrowser()) {
          // eslint-disable-next-line
          console.error(new Error('spid bearer token is invalid while logged in.'));
          window.location.reload();
        } // Retry the fetch once with a fresh apiKey bearerToken.


        return dispatch(authenticationActions.fetchBearerToken('apiKey')).then(function () {
          return axiosFetch(url, params, getState().authentication.bearerToken);
        });
      }

      return response;
    })["catch"](function (error) {
      // eslint-disable-next-line
      console.info("fetch failed, retrying once: ".concat(error));
      return axiosFetch(url, params, getState().authentication.bearerToken);
    }).then(handleApiResponse)["catch"](function (error) {
      // eslint-disable-next-line no-param-reassign
      error.url = url;
      throw error;
    });
  };
};

var amokApiFetch = function amokApiFetch(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    return dispatch(apiFetch("".concat(getState().config.urls.api, "/").concat(path), params));
  };
};

var templateApiFetch = function templateApiFetch(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    return dispatch(apiFetch("".concat(getState().config.urls.api, "/blocket/v7/template_proxy/").concat(path), params));
  };
};

var legacyApiFetch = function legacyApiFetch(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (dispatch, getState) {
    return dispatch(apiFetch("".concat(getState().config.urls.api, "/").concat(path), _objectSpread(_objectSpread({}, params), {}, {
      headers: _objectSpread(_objectSpread({}, params.headers), {}, {
        'X-Accept-Charset': 'utf-8'
      })
    })));
  };
};

export var actionCreators = {
  fetch: amokApiFetch,
  legacyApiFetch: legacyApiFetch,
  templateApiFetch: templateApiFetch
};
//# sourceMappingURL=actions.js.map